<template>
    <div class="search-members" :class="{'is-active': showForm}">
        <form v-if="showForm" class="chat-head__search" @submit.prevent="search">
            <div class="search-controls">
                <img
                    :src="env.public_base + '/assets/images/cross-icon.svg'"
                    @click="removeFoundMembers"
                    alt=""
                    v-if="value !== ''"
                    class="search-buttons"
                >
            </div>
            <label class="search__label" for=""></label>
            <input class="search__input" v-model="value" @keyup="search" type="text" :placeholder="$t('search_members')">
        </form>
        <button class="search__button" @click="openForm">
            <img :src="env.public_base + '/assets/images/search-icon.svg'" alt="">
        </button>
    </div>
</template>

<script>
    import env from '../../env';
    import { mapGetters } from 'vuex';

    export default {
        data: () => {
            return {
                env,
                showForm: false,
                value: ''
            }
        },
        computed: {
            ...mapGetters([
                'channel',
            ]),
        },
        methods: {
            removeFoundMembers() {
                this.value = '';
                this.$store.commit('SET_SEARCH_MEMBERS', null);
            },
            search() {
                if(this.value === '' || this.value.length === 0) {
                    this.removeFoundMembers();
                    return;
                }

                if (this.value.length > 1) {
                    let params = {
                        'q': this.value
                    };
                    this.$store.dispatch('searchMembers', params);
                }
            },
            openForm() {
                this.showForm = !this.showForm
            }
        },
        watch: {
            '$route' (to, from) {
                this.value = '';
                this.$store.commit('SET_SEARCH_MEMBERS', null);
                this.showForm = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../sass/variables';

    .search-members {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 23px 35px 17px;

        .search-controls {
            background-color: $white;
        }

        .chat-head__search {
            width: 100%;

            .search__input {
                font-size: 12px;
                min-width: 0;
            }
        }

        .search__button {
            height: 100%;
            top: 0;
            border-radius: 3px;
        }

        &.is-active {

            .search__button {
                border-radius: 0 3px 3px 0;
            }
        }

        @media screen and (max-width: 767px) {
            min-height: 32px;

            .chat-head__search {
                margin-top: 0;
            }
        }
    }
</style>